import React from "react";
import MultiPickerListWithSelectedItems from "../MultiPickerListWithSelectedItems";
import { MultiPickerListProps } from "../props";
import SubLabel from "components/Atoms/Sublabel";

const perPage = 20;

const MultiCostCenterList = (props: MultiPickerListProps<server.dto.CostCenter>) => {
  const [instruction, setInstruction] = React.useState<server.dto.ListCostCenterInstruction>({
    page: 1,
    perPage: perPage,
    visible: "onlyYes",
    keyword: ""
  });

  const setFilter = (visible: server.dto.BooleanFilterSettings) => { setInstruction(instr => ({ ...instr, visible, page: 1 })); };

  return <MultiPickerListWithSelectedItems
    instruction={instruction}
    onInstructionChange={setInstruction}
    queryKey="costCenters"
    api={window.CoreApi.CostCenter.ListCostCenter}

    getError={() => undefined}
    excludeKeys={props.excludeKeys}

    onChange={props.onChange}
    getId={cc => cc.costCenterId}
    renderListItem={cc => <div>
      <div>{cc.internalId}</div>
      <SubLabel>{cc.title}</SubLabel>
    </div>}
    getLabel={cc => <div>{cc.internalId}</div>}
    value={props.value}

    filter1={{
      leftButton: {
        type: "primary",
        isActive: instruction.visible === "onlyYes",
        label: RESX.SoUser.Active,
        onClick: () => { setFilter("onlyYes"); }
      },
      rightButton: {
        type: "primary",
        isActive: instruction.visible === "onlyNo",
        label: RESX.SoUser.Deactivated,
        onClick: () => { setFilter("onlyNo"); }
      }
    }}
  />
};

export default MultiCostCenterList;